import { render, staticRenderFns } from "./SurveyResponsesPage.vue?vue&type=template&id=8e791578"
import script from "./SurveyResponsesPage.vue?vue&type=script&lang=js"
export * from "./SurveyResponsesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports